<template>
  <div class="content_main">
		<div class="content_main_top">
			<a-input placeholder="请输入审批编号" allowClear class="a_input_self margin_self" v-model="queryParam.applyCode"
				@keyup.enter.native="query" />
            <a-input placeholder="请输入申请人" allowClear class="a_input_self margin_self" v-model="queryParam.applyer"
				@keyup.enter.native="query" />
			<a-select placeholder="请选择状态" class="a_input_self margin_self" v-model="queryParam.status" allowClear
				@keyup.enter.native="query">
				<!-- <a-select-option :value="''">全部</a-select-option> -->
				<a-select-option v-for="(val, key) in status_apply" :key="key" :value="key">{{ val.txt }}
				</a-select-option>
			</a-select>
			<a-select placeholder="请选择审批结果" class="a_input_self margin_self" v-model="queryParam.result" allowClear
		         @keyup.enter.native="query">
				<!-- <a-select-option :value="''">全部</a-select-option> -->
				<a-select-option v-for="(val, key) in resultMap" :key="key" :value="key">{{ val }}</a-select-option>
			</a-select>
            <a-range-picker valueFormat="YYYY-MM-DD" style="margin-right: 10px; width: 220px" allowClear :value="dates"
            @change="onChange" :placeholder="['申请开始时间', '申请结束时间']" @keyup.enter.native="query" />
			<a-button type="primary" @click="query">查询</a-button>
			<a-button style="margin-left: 8px" @click="result">重置</a-button>
			<a-button type="primary" @click="applyEvent">新增申请</a-button>
			<!-- <a-button type="danger" v-if="selectedRowKeys.length > 0 && deleteBusinessList" icon="delete" @click="delByIds(selectedRowKeys)">删除</a-button> -->
		</div>
		<div class="content_main_center" id="content_main_center_scroll">
            <a-table :data-source="applyLis" bordered :loading="loading" :pagination="false" 
                :scroll="{ y: scroll_y, scrollToFirstRowOnChange: true }">
                <a-table-column key="index" title="序号" data-index="index" width="70px">
                    <template scope="text, record, index">{{ (pagination.current - 1) * pagination.pageSize + index + 1 }}
                    </template>
                </a-table-column>
                <a-table-column key="applyCode" ellipsis="true" title="审批编号" data-index="applyCode" />
                <a-table-column key="applyer" ellipsis="true" title="申请人" data-index="applyer" />
                <a-table-column key="title" ellipsis="true" title="申请标题" data-index="title" />
                <a-table-column key="applyTime" ellipsis="true" title="申请时间" data-index="applyTime" />
                <a-table-column key="status" ellipsis="true" title="状态" data-index="status" >
                     <template scope="text">
                         <span class="tag_class"
                            :style="{ background: status_apply[text].color }">
                            {{ status_apply[text].txt }}
                        </span>
                     </template>
                </a-table-column>
                <a-table-column key="result" ellipsis="true" title="审批结果" data-index="result" >
                     <template scope="text">
                        <span class="tag_class"
                        :style="{ background: result_apply[text].color }">
                        {{ result_apply[text].txt }}
                        </span>
				    </template>
                </a-table-column>
                 <a-table-column  title="操作" width="170px">
                    <template scope="text, record">
                        <a @click="detail(record)">详情</a>
                        <a-divider type="vertical" />
                        <a @click="handFlow(record)">历史</a>
                        <a-divider type="vertical" />
                        <a @click="cancel(record)" :disabled="record.status !== 1">撤销</a>
                    </template>
                </a-table-column>
            </a-table>
            <div class="pageBottom">
                <a-pagination v-model="pagination.current" show-size-changer :page-size.sync="pagination.pageSize"
                    :total="pagination.total" @showSizeChange="onShowSizeChange"
                    :pageSizeOptions="['10', '20', '30', '40', '50']" @change="onShowSizeChange" />
            </div>
        </div>
        <!-- 申请弹窗 -->
        <a-modal v-model="contractView" title="合同项目修改" width="60%"  @cancel="closeView">
			<template slot="footer">
				<a-button key="submit" type="primary" @click="contractOk"> 提交 </a-button>
				<a-button key="back" @click="closeView"> 取消 </a-button>
			</template>
			<a-form-model :model="contractForm" ref="contractRef" :label-col="labelCol3" :wrapper-col="wrapperCol3">
                <a-form-model-item label="选择抄送人" :label-col="labelCol2" :wrapper-col="wrapperCol2">
                    <ccChange :data="ccC" @targetKeys="currencygetdata" v-if="contractView" />
                </a-form-model-item>
				<a-row>
                    <a-col :span="12">
						<a-form-model-item label="原项目编号" prop="identifier" >
							<a-input v-model="contractForm.identifier" placeholder="请输入" @blur="getInfor"></a-input>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="原项目类型" prop="type" disabled>
							<a-input v-model="contractForm.type" placeholder="请输入"></a-input>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
                        <a-form-model-item label="原合同编号" prop="contractIdentifier" disabled>
							<a-input v-model="contractForm.contractIdentifier" placeholder="请输入"></a-input>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="原合同类型" prop="contractType" disabled>
							<a-input v-model="contractForm.contractType" placeholder="请输入"></a-input>
						</a-form-model-item>
					</a-col>
                </a-row>
				<a-row>
					 <a-col :span="12">
						<a-form-model-item label="当前项目状态" prop="status" :label-col="labelCol3" :wrapper-col="wrapperCol3">
                                <a-select allowClear placeholder="请选择" v-model="contractForm.status" disabled>
                                    <a-select-option :value="item.id" v-for="(item, index) in statusList"
                                        :key="index">
                                        {{ item.title }}
                                    </a-select-option>
                                </a-select>
						</a-form-model-item>
					</a-col>
                    <a-col :span="12">
                        <span style="color:red;margin-left:20px;line-height:40px;"><a-icon type="exclamation-circle" />项目状态为录入的项目可提交申请</span>
                    </a-col>
                </a-row>
                <div style="padding: 10px 0;border-top:1px soild #ccc;">信息修改</div>
                <a-row>
                    <a-col :span="12">
                          <a-form-model-item label="项目类型" prop="typeNew" :rules="{
							required: true,
							message: '请选择项目类型',
							trigger: 'change',
						}">
							<a-select allowClear placeholder="请选择" v-model="contractForm.typeNew"
								@change="handlecompanyplan($event,0)">
								<a-select-option :value="item.name" v-for="(item, index) in typeList"
									:key="index">
									{{ item.name }}
								</a-select-option>
							</a-select>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
                        <a-form-model-item label="项目编号" prop="identifierNew" :rules="{
							required: true,
							message: '请输入项目编号',
							trigger: 'change',
						}">
							<a-input v-model="contractForm.identifierNew" placeholder="请输入"></a-input>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
                      <a-form-model-item label="合同类型" prop="contractTypeNew" :rules="{
							required: true,
							message: '请选择合同类型',
							trigger: 'change',
						}" >
							<a-select allowClear placeholder="请选择" v-model="contractForm.contractTypeNew" disabled>
								<a-select-option :value="item" v-for="(item, index) in contractTypeList"
									:key="index">
									{{ item }}
								</a-select-option>
							</a-select>
                        </a-form-model-item>
					</a-col>
					<a-col :span="12">
                        <a-form-model-item label="合同编号" prop="contractIdentifierNew" :rules="{
							required: true,
							message: '请输入合同编号',
							trigger: 'change',
						}">
							<a-input v-model="contractForm.contractIdentifierNew" placeholder="请输入" :disabled="isSame"></a-input>
						</a-form-model-item>
					</a-col>
                </a-row>
				<a-row>
					 <a-col :span="24">
						<a-form-model-item label="修改原因" prop="reason" :label-col="labelCol2" :wrapper-col="wrapperCol2" :rules="{
							required: true,
							message: '请输入修改原因',
							trigger: 'change',
						}">
							<a-textarea :auto-size="{ minRows: 2, maxRows: 10 }" v-model="contractForm.reason" allowClear placeholder="请输入" ></a-textarea>
						</a-form-model-item>
					</a-col>
                </a-row>
			</a-form-model>
		</a-modal>
        <contractDetail ref="contractDetail" :audit="false"></contractDetail>
        <proc-flow-modal ref="modalflow" @ok="handleOk" />
  </div>
</template>

<script>
import ProcFlowModal from '@/views/activiti/modules/ProcFlowModal.vue' //历史
import {resultMap, delProcessIns} from '@/api/activiti'
import ccChange from '@/components/module/ccChange'
import contractDetail from './contractDetail.vue'
import { contractProject, contractProjectSave, projectList, projectType, bidCode} from '@/api/budget'
import { businesslist } from '@/api/assetmenag'

export default {
    components: {
        ccChange,
        contractDetail,
        ProcFlowModal
    },
    data() {
        return {
            resultMap,
            queryParam: {
                applyCode: '',
                applyer: '',
                status: undefined,
                start_date: '',
                end_date: '',
                result: undefined,

            },
            applyLis:[],
            scroll_y: 150,
            dates: [],
            pagination: {
					current: 1,
					pageSize: 10,
					total: 0,
					pageSizeOptions: ['10', '20', '30', '40', '50'],
					showSizeChanger: true,
					itemName: '',
					hideOnSinglePage:false
				},
                contractView: false,
                contractForm: {
                    cc: '',
                    identifier: '',
                    type: '',
                    contractType: '',
                    contractIdentifier: '',
                    status: '',
                    contractIdentifierNew: '',
                    typeNew: undefined,
                    contractTypeNew: undefined,
                    identifierNew: '',
                    reason: '',
                    applyCode: '',
                },
                ccC: 'contract-project',
            labelCol2: {
				span: 4
			},
			wrapperCol2: {
				span: 20
			},
            labelCol3: {
				span: 8
			},
			wrapperCol3: {
				span: 16
			},
            statusList:[{
                id: 1,
                title: '项目录入',
            },{
                id: 2,
                title: '任务分配',
            },{
                id: 5,
                title: '采样',
            },{
                id: 10,
                title: '收样',
            },{
                id: 20,
                title: '检测报告',
            },{
                id: 30,
                title: '报告装订',
            },{
                id: 40,
                title: '质控签发',
            },{
                id: 50,
                title: '报告寄送',
            },{
                id: 60,
                title: '项目归档',
            },{
                id: 70,
                title: '项目结束',
            },{
                id: 98,
                title: '任务挂起',
            },{
                id: 99,
                title: '项目中止',
            }],
            typeList: [],
            contractTypeList: [],
            isSame: false
        }
    },
    created() {
        this.query()
      

    },
    mounted() {
    this.$nextTick(() => {
      var max_h = $('#content_main_center_scroll').height()
      setTimeout(() => {
        this.scroll_y = max_h - $('.ant-table-header').height() -40
      }, 1000)
    })
  },
    methods: {
        //撤销
        cancel(data) {
            var ids = data.procInstId
            var _this = this
            this.$confirm({
                title: '是否确认撤销?',
                onOk() {
                    delProcessIns({
                        ids: ids,
                        reason: '主动撤销',
                    }).then((res) => {
                        if (res.code === 200) {
                            _this.$message.success('撤销成功')
                            _this.query()
                        }else {
                            _this.$message.error(res.msg)
                        }
                    })
                }
            })
		},
        //历史
        handFlow(row) {
            var obj = {
				procInstId: row.procInstId,
				procDefKey: row.procDefKey
			}
            this.$refs.modalflow.show(obj)
        },
        //新增申请
        applyEvent() {
            //  this.contractView = true
             bidCode().then(res => {
                if(res.code == 200) {
                    this.contractView = true
                    this.contractForm.applyCode = res.data
                } else {
                    this.$message.error(res.msg)
                }
            })
            // this.getInfor()

        },
        //关闭弹窗
        closeView() {
            this.isSame = false
			this.$refs.contractRef.resetFields()
            this.contractForm = {
                    cc: '',
                    identifier: '',
                    type: '',
                    contractType: '',
                    contractIdentifier: '',
                    status: '',
                    contractIdentifierNew: '',
                    typeNew: undefined,
                    contractTypeNew: undefined,
                    identifierNew: '',
                    reason: '',
                    applyCode: '',
                }
            this.contractView = false
        },
        // 获取合同类型
        handlecompanyplan(e,data) {
           var contractTypeList = []
            projectType().then(res => {
                if(res.code === 200) {
                   this.typeList =  res.data
                   this.typeList.forEach(item => {
                    if(item.name === e) {
                        contractTypeList.push(item.module)
                    }
                    })
                    if(data === 1) {
                        this.contractForm.contractType = Array.from(new Set(contractTypeList))[0]
                    } else {
                        if(this.contractForm.type === this.contractForm.typeNew) {
                            this.isSame = true
                            this.contractForm.contractIdentifierNew = this.contractForm.contractIdentifier
                        } else {
                            this.isSame = false
                            this.contractForm.contractIdentifierNew = ''
                        }
                        this.contractTypeList =  Array.from(new Set(contractTypeList))
                        this.contractForm.contractTypeNew = this.contractTypeList[0]
                    }
                this.$forceUpdate()
                } else {
                    this.$message.error(res.msg)
                }
            })
            
            
            console.log(e,data,this.contractForm.contractType,'eeeeeeeeeeeeeeeeeeeeeeeeeeeeeee')
        },
        onChange(date, dateString) {
            this.dates = date
            this.queryParam.start_date = date[0]
            this.queryParam.end_date = date[1]
        },
        // 查询
        query() {
            businesslist({
                function: 'cp',
                pageNum: this.pagination.current,
		        pageSize: this.pagination.pageSize,
                procDefKey: 'contract-project',
                applyCode: this.queryParam.applyCode,
                applyer: this.queryParam.applyer,
                status: this.queryParam.status,
                startTime: this.queryParam.start_date,
                endTime: this.queryParam.end_date,
                result: this.queryParam.result,
            }).then(res => {
                if(res.code == 200) {
                    this.applyLis = res.rows
                    this.pagination.total = res.total
                } else {
                    this.$message.error(res.msg)
                }
            })

        },
        //重置
        result() {
            this.queryParam = {
                applyCode: '',
                applyer: '',
                status: undefined,
                start_date: '',
                end_date: '',
                result: undefined,
            },
            this.dates = []
            this.pagination.current = 1
            this.query()
        },
        
        onShowSizeChange(current, pageSize) {
            this.pagination.current = current
            this.pagination.pageSize = pageSize;
            //重新渲染数据
            this.query()
        },
        currencygetdata(data) {
			this.contractForm.cc = data
		},
        //详情页面
        detail(record) {
            Object.assign(record, {
                businessKey: record.id,
            })
            this.$refs.contractDetail.show(record)
        },
        //提交申请
        contractOk() {
            // 1、合同类型与原合同类型一致，只需要修改项目编号与项目类型，并且项目状态为“录入”的。
            // 2、合同类型与原合同类型不一致，但此合同下只有一个项目，并且项目状态为“录入”的
            if(this.contractForm.type === this.contractForm.typeNew ) {
                if(this.contractForm.status != 1) {
                  return this.$message.warning('合同类型一致时，项目状态必须为录入才可提交申请！')
                }
            } else {
                if(this.inforData.length != 1 && this.inforData.sstatus != 1){
                    return this.$message.warning('合同类型不一致时，此合同下只有一个项目，并且项目状态为“录入”的才可提交申请！')
                }
            }
            this.$refs.contractRef.validate((valid) => {
			    if (valid) {
                    this.$store.commit('LOADING', true)
                    this.$store.commit('TIPS', '提交中......')
                    contractProjectSave({
                        identifier: this.contractForm.identifier,
                        /** 项目类型 */
                        type: this.contractForm.type,
                        /** 合同类型 */
                        contractType: this.contractForm.contractType,
                        /** 合同编号 */
                        contractIdentifier: this.contractForm.contractIdentifier,
                        /** 项目编号(新) */
                        identifierNew: this.contractForm.identifierNew,
                        /** 项目类型(新) */
                        typeNew: this.contractForm.typeNew,
                        /** 合同类型(新) */
                        contractTypeNew: this.contractForm.contractTypeNew,
                        /** 合同编号(新) */
                        contractIdentifierNew: this.contractForm.contractIdentifierNew,
                        /** 抄送人 */
                        cc: this.contractForm.cc.join(),
                        status: this.contractForm.status,
                        /** 修改原因 */
                        reason: this.contractForm.reason,
                        /** 审批编号 */
                        applyCode: this.contractForm.applyCode,
                    }).then(res => {
                        this.$store.commit('LOADING', false)
                        this.$store.commit('TIPS', '加载中......')
                        if(res.code == 200) {
                            this.$message.success(res.msg)
                            //刷新页面
                            this.query()
                        } else {
                            this.$message.error(res.msg)
                        }
                        this.closeView()

                    })
                    
                }
            })
        },
        getInfor() {
            if(this.contractForm.identifier) {
                contractProject({
                    identifier: this.contractForm.identifier
                }).then(res => {
                    if(res.code == 200) {
                        if(res.data.length<1) {
                        return  this.$message.error('未查询到该项目信息！')
                        }
                        this.inforData = res.data
                        res.data.forEach(item => {
                            if(item.identifier === this.contractForm.identifier){
                                this.contractForm.type = item.type
                                this.contractForm.contractIdentifier = item.contractIdentifier
                                this.contractForm.status = item.status
                                this.handlecompanyplan(item.type,1)

                            }
                        });
                    }else {
                        this.$refs.console.error(res.msg)
                    }
                })
            }
        }
    }

}
</script>

<style lang="less" scoped>
    .pageBottom {
        width: 100%;
        height: 35px;
        float: left;
        display: flex;
        justify-content: flex-end;
        align-items: flex-end;
        margin-top: 10px;
    }

</style>